module.exports = new __parcel__URL__("soleil-voile-pluie-1.0b00ef42.svg").toString();